<template>
  <div class="content">
    <div class="form-box">
      <el-form :inline="true" :model="formInline" :label-position="labelPosition" :rules="rules" ref="formInline"
               class="demo-form-inline">
        <el-form-item label="公司名称" prop="company">
          <el-input v-model="formInline.company" placeholder="公司名称"></el-input>
        </el-form-item>
        <el-form-item label="法人代表" prop="representative">
          <el-input v-model="formInline.representative" placeholder="法人代表"></el-input>
        </el-form-item>
        <el-form-item label="咨询者" prop="advice">
          <el-input v-model="formInline.advice" placeholder="咨询者"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input maxlength="11" v-model.number="formInline.phone" autocomplete="off" placeholder="联系电话"></el-input>
        </el-form-item>
        <el-form-item label="诊断场所" prop="address">
          <el-input v-model="formInline.address" placeholder="诊断场所"></el-input>
        </el-form-item>
        <el-form-item label="公司状况" prop="enterprise_years">
          <el-select v-model="formInline.enterprise_years" placeholder="公司状况">
            <el-option v-for="(index,key) in enterprise_yearss" :key="key" :label="index.name"
                       :value="index.name">{{index.type}}、{{index.name}}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司形态" prop="service_type">
          <el-select v-model="formInline.service_type" placeholder="公司形态">
            <el-option v-for="(index,key) in service_types" :key="key" :label="index.name"
                       :value="index.name">{{index.type}}、{{index.name}}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="股东关系" prop="personnel_size">
          <el-select v-model="formInline.personnel_size" placeholder="股东关系">
            <el-option v-for="(index,key) in personnel_sizess" :key="key" :label="index.name"
                       :value="index.name">{{index.type}}、{{index.name}}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="btn-form">
          <el-button @click="resetForm('formInline')">重置</el-button>
          <el-button type="primary" @click="onSubmit('formInline')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" custom-class="xiepulou">
     <div class="img-box">
       <img src="/static/image/tianjia.jpg" alt="" class="ti-pic">
       <img src="/static/image/shoukuan.jpg" alt="" class="ti-pic">
     </div>
      <span>此次诊断费用({{pi}}元)<div class="feiyong">{{text}}</div>，请扫码付款，添加二维码微信，获取测评二维码</span>
<!--      <el-button class="btn" type="danger" @click="to">确定</el-button>-->
    </el-dialog>
  </div>
</template>
<script>
var indexurl = localStorage.getItem('url')
export default {

  data() {
    return {
      pi:'',
      uname:'',
      id: '',
      dialogVisible: false,
      labelPosition: 'right',
      text:'',
      formInline: {
        company: '',
        phone: '',
        address: '',
        service_type: "",
        personnel_size: "",
        enterprise_years: "",
        representative:'',
        advice:'',

      },
      service_types: [{
        id:1,
        name:'服务业',
        type:'1'
      },{
        id:2,
        name:'高科技',
        type:'2'
      },{
        id:3,
        name:'传统行业',
        type:'3'
      }],
      personnel_sizes: [],
      personnel_sizess: [{
        id:1,
        name:'亲戚：夫妻、兄弟等',
        type:'1'
      },{
        id:2,
        name:'朋友：战友、难兄难弟',
        type:'2'
      },{
        id:3,
        name:'一般关系：兴趣爱好者、朋友介绍、公司内部人员',
        type:'3'
      }],
      personnel_sizesss: [],
      enterprise_yearss: [
        {
          id:1,
          name:'初创(设想)',
          type:'A'
        },{
          id:1,
          name:'经营3年以下',
          type:'B'
        },{
          id:1,
          name:'经营3年以上',
          type:'C'
        }],
      show:true,
      shows:false,
      rules: {
        company: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
        representative: [
          {required: true, message: '请输入发人代表', trigger: 'blur'}
        ],
        advice: [
          {required: true, message: '请输入咨询者', trigger: 'blur'}
        ],
        phone: [
          {required: false, message: '请输入手机', trigger: 'blur'},
          {type: 'number', message: '手机必须为数字值'}
        ],
        address: [
          {required: false, message: '请输入推荐场所', trigger: 'blur'}
        ],
        enterprise_years: [
          {required: true, message: '请选择公司状况', trigger: 'change'}
        ],
        service_type: [
          {required: true, message: '请选择公司形态', trigger: 'change'}
        ],
        personnel_size: [
          {required: true, message: '请选择股东关系', trigger: 'change'}
        ]
      }
    }
  },
  created() {
    this.id = this.$route.query.id
    this.uname = this.$route.query.name
    this.serviceMode()
    this.personnelSize()
    this.enterpriseYears()
  },
  methods: {
    houver(){
      this.show = false
      this.shows = true
    },
    serviceMode() {
      // let that = this
      // this.$axios({
      //   method: "GET",
      //   url: indexurl + "/index.php/api/index/getServerType",
      //   data: {}
      // })
      //   .then(function (res) {
      //     console.log(res,'service_type')
      //     let arr = Object.keys(res.data.data).map(key => {
      //       return res.data.data[key];
      //     });
      //     that.service_types = arr
      //   })
    },
    personnelSize() {
      // let that = this
      // this.$axios({
      //   method: "GET",
      //   url:indexurl + "/index.php/api/index/getPersonnelSize",
      //   data: {}
      // })
      //   .then(function (res) {
      //     let arr = Object.keys(res.data.data).map(key => {
      //       return res.data.data[key];  //把每个对象返回出去生成一个新的数组中相当于0:{id:1}
      //     });
      //     that.personnel_sizes = arr
      //     // that.personnel_sizess.push(that.personnel_sizes[0])
      //     // that.personnel_sizess.push(that.personnel_sizes[1])
      //     // that.personnel_sizess.push(that.personnel_sizes[2])
      //     // that.personnel_sizesss.push(that.personnel_sizes[3])
      //     // that.personnel_sizesss.push(that.personnel_sizes[4])
      //     // that.personnel_sizesss.push(that.personnel_sizes[5])
      //   })
    },
    enterpriseYears() {
      // let that = this
      // this.$axios({
      //   method: "GET",
      //   url: indexurl + "/index.php/api/index/getCompanyYears",
      //   data: {}
      // })
      //   .then(function (res) {
      //     let arr = Object.keys(res.data.data).map(key => {
      //       return res.data.data[key];  //把每个对象返回出去生成一个新的数组中相当于0:{id:1}
      //     });
      //     that.enterprise_yearss = arr
      //   })
    },
    onSubmit(formName) {
      let str = String(this.formInline.phone)
      if(str.length != 11){
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        });
        return
      }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let that = this
            this.$axios({
              method: "POST",
              url: indexurl + "/index.php/api/index/addInfo",
              data: {
                company: this.formInline.company,
                phone: this.formInline.phone,
                address: this.formInline.address,
                service_type: this.formInline.service_type,
                personnel_size: this.formInline.personnel_size,
                enterprise_years: this.formInline.enterprise_years,
                job: this.formInline.representative,
                user_name:this.formInline.advice
              }
            })
              .then(function (res) {
                that.pi = res.data.data.price
                that.$axios({
                  method: "GET",
                  url: indexurl + "/index.php/api/index/retFee",
                  data: {
                    cp_category_id:that.id,
                    service_type:that.formInline.service_type,
                    personnel_size:that.formInline.personnel_size
                  }
                })
                  .then(function (res) {
                    that. resetForm('formInline')
                    that.dialogVisible = true;
                    that.text = res.data.data.fee
                  })
              })
          } else {
            return false;
          }
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
}
</script>
<style scoped>
.content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
}
.form-box {
  /*position: absolute;*/
  /*top: 50%;*/
  /*left: 50%;*/
  /*transform: translate(-50%, -50%);*/
  width: 50%;
  box-shadow: 0 0 15px 15px rgba(0, 0, 0, 0.34);
  padding: 20px;
  border-radius: 10px;
}
.demo-form-inline {
  display: flex;
  flex-direction: column;
}
.ti-pic {
  width: 50%;
}
.el-form-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
/deep/ .el-form--inline .el-form-item__label {
  width: 30%;
  text-align: start;
}
/deep/ .el-form--inline .el-form-item__content {
  width: 70%;
}
.el-select {
  width: 100%;
}
/deep/ .btn-form .el-form-item__content {
  width: 100%;
  flex: unset;
  display: flex;
  justify-content: space-between;
}
.tishi{
  font-size: 12px;
  color: red;
  margin-bottom: 22px;
}
.feiyong{
  font-size: 24px;
  color: red;
  display: initial;
}
.img-box{
  display: flex;justify-content: space-between;align-items: center;
}

/deep/.el-dialog__body{
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 800px) {
  .form-box {
    width: 80%;
    position: unset;
    top: unset;
    left: unset;
    transform: unset;
    margin: 20px auto;
  }
  /deep/ .el-form--inline .el-form-item__content{
    width: 100%;
  }
}
@media (max-width: 768px) {
  .form-box {
    width: 80%;
    position: unset;
    top: unset;
    left: unset;
    transform: unset;
  }
  .img-box{
    display: flex;justify-content: center;align-items: center;flex-direction: column;
  }
  .ti-pic {
    width: 100%;
  }
  /deep/.el-dialog{
    width: 80%!important;
  }
}
@media (max-width: 480px) {
  /deep/ .el-form--inline .el-form-item__label {
    width: 36%;
    text-align: start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/information/index.vue